import React from "react";
import { styled } from "@mui/material/styles";
import { ListItemButton, ListItemButtonProps } from "@mui/material";
import { theme } from "themes/theme";

interface ICListItemButton extends ListItemButtonProps {
  isSelected?: boolean;
  isChild?: boolean;
}

const ListItemCustomComponent = <C extends React.ElementType>(
  props: ListItemButtonProps<C, { component?: C }>
) => {
  return <ListItemButton {...props} />;
};

export const CListItemButton = styled(ListItemCustomComponent)(
  (props: ICListItemButton) => ({
    paddingLeft: 8,
    height: props.isChild ? 40 : 48,
    backgroundColor: props.isSelected ? theme.palette.primary.main : "white",
    marginRight: "16px",
    marginBottom: props.isChild ? "6px" : 0,
    borderRadius: "6px 100px 100px 0px",
  })
);
